// eslint-disable-next-line no-shadow
export enum FormInputFilter {
  date = 'date',
  serialNumber = 'serialNumber',
}
